__turbopack_context__.v({
  "container": "error-module-scss-module__ZDrz2W__container",
  "content": "error-module-scss-module__ZDrz2W__content",
});
